// extracted by mini-css-extract-plugin
module.exports = {"message":"components-Loader-Loader__message--2062I","sign-in-loader":"components-Loader-Loader__sign-in-loader--1oSE3"};